import React from 'react'

const SpinnerLoader = props => (<div className="d-flex justify-content-center align-items-center" style={{height: "100%", width: "100%"}}>
  <div className="spinner-border" role="status">
    <span className="sr-only">Loading...</span>
  </div> 
</div>)

export default SpinnerLoader